import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { CommentViewModel, CommentType } from '@models/Comment';
import { Comment } from './comment.container';

// Defining the properties the component expects
// Consider this the "setup" of the component
// All properties should be readonly
export interface ActionCompleteComponentProperties extends RouteComponentProps<{ id?: number }> {
  readonly oldComment: CommentViewModel;
  readonly commentId?: number;
  readonly entityId: number;
  readonly comment: CommentViewModel;
  readonly commentType: CommentType;
  readonly saveCallback: Function;
  readonly hideSave: boolean;
}

// Component definition
export class ActionCompleteComponent extends React.Component<ActionCompleteComponentProperties> {
  render() {
    return (
      <>
        <div className="row">
          <div className="col-md-12 mb-10">
            <h3> Action Item </h3>
            <p>{this.props.oldComment.comment}</p>
          </div>
        </div>
        <h3>I did this to resolve the item...</h3>
        <Comment
          entityId={this.props.entityId}
          saveCallback={this.props.saveCallback}
          commentType={this.props.commentType}
          hideSave={this.props.hideSave}
          {...this.props}
        />
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/comments/_components/comment/action-complete.component.tsx